export const GraduationHat = (props) => {
  const width = (props.size * 25) / 24 || 24;
  const height = props.size || 24;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0005 13V9.50001L21.0005 8.50001M5.00055 10.5V15.9121C5.00055 16.6844 5.44514 17.3876 6.14274 17.7188L11.1427 20.0928C11.6856 20.3505 12.3155 20.3505 12.8583 20.0928L17.8584 17.7188C18.556 17.3876 19.0005 16.6844 19.0005 15.9121V10.5M11.7322 4.13417L3.07386 8.46336C2.63163 8.68447 2.63163 9.31555 3.07386 9.53667L11.7322 13.8658C11.9011 13.9503 12.1 13.9503 12.2689 13.8658L20.9272 9.53667C21.3695 9.31555 21.3695 8.68447 20.9272 8.46335L12.2689 4.13418C12.1 4.04972 11.9011 4.04972 11.7322 4.13417Z"
        stroke={props.color || 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
